import { lazy } from "react";
import {
  DatabaseOutlined,
  UnlockOutlined,
  TeamOutlined,
  SafetyCertificateOutlined,
  DownloadOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  HomeOutlined,
  GoldOutlined,
  ProductOutlined,
  FileTextOutlined,
  BankOutlined,
  FileDoneOutlined,
  FileProtectOutlined,
  InsertRowBelowOutlined,
  ReconciliationOutlined,
  CalculatorOutlined,
  DiffOutlined,
} from "@ant-design/icons";
import { CiMonitor } from "react-icons/ci";

// Lazy-loaded Pages
const Dashboard = lazy(() => import("../pages/auth/Dashboard"));
const Users = lazy(() => import("../pages/auth/MasterData/Users"));
const Privilege = lazy(() => import("../pages/auth/MasterData/Privilege"));
const AccessControlList = lazy(() => import("../pages/auth/MasterData/AccessControlList"));
const Inbound = lazy(() => import("../pages/auth/Inbound"));
const Outbound = lazy(() => import("../pages/auth/Outbound"));
const DeviceSensor = lazy(() => import("../pages/auth/MasterData/DeviceSensor"));
const Warehouse = lazy(() => import("../pages/auth/MasterData/Warehouse"));
const Pallet = lazy(() => import("../pages/auth/MasterData/Pallet"));
const Product = lazy(() => import("../pages/auth/MasterData/Product"));
const Reports = lazy(() => import("../pages/auth/Reports"));
const Area = lazy(() => import("../pages/auth/MasterData/Area"));
const ProductType = lazy(() => import("../pages/auth/MasterData/ProductType"));
const ProductCost = lazy(() => import("../pages/auth/MasterData/ProductCost"));
const Invoice = lazy(() => import("../pages/auth/Invoice"));
const Rules = lazy(() => import("../pages/auth/Rules"));
const StockOpname = lazy(() => import("../pages/auth/StockOpname"));
const StockOverview = lazy(() => import("../pages/auth/StockOverview"));
const MaterialHandling = lazy(() => import("../pages/auth/MasterData/MaterialHandling"));

export const MENU_LIST = [
  {
    name: "Dashboard",
    code: "Dashboard",
    icon: <CiMonitor />,
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    name: "Inbound",
    code: "Inbound",
    icon: <DownloadOutlined />,
    path: "/inbound",
    element: <Inbound />,
  },
  {
    name: "Outbound",
    code: "Outbound",
    icon: <UploadOutlined />,
    path: "/outbound",
    element: <Outbound />,
  },
  {
    name: "Transaction",
    code: "Transaction",
    icon: <FileTextOutlined />,
    path: "/transaction",
    element: <Invoice />,
  },
  {
    name: "Reports",
    code: "Report",
    icon: <FileDoneOutlined />,
    path: "/reports",
    element: <Reports />,
  },
  {
    name: "Stock Opname",
    code: "Stock Opname",
    icon: <InsertRowBelowOutlined />,
    path: "/stock-opname",
    element: <StockOpname />,
  },
  {
    name: "Stock Overview",
    code: "Stock Overview",
    icon: <ReconciliationOutlined />,
    path: "/stock-overview",
    element: <StockOverview />,
  },
  {
    name: "Policy & Price List",
    code: "Policy & Price List",
    icon: <FileProtectOutlined />,
    path: "/policy",
    element: <Rules />,
  },
  {
    name: "Calculator Biaya Penyimpanan",
    code: "Calculator Biaya",
    icon: <CalculatorOutlined />,
    path: "/calculator",
    newTab: true,
  },
  {
    name: "Master Data",
    code: "Master Data",
    icon: <DatabaseOutlined />,
    children: [
      {
        name: "Users",
        code: "Users",
        icon: <TeamOutlined />,
        path: "/users",
        element: <Users />,
      },
      {
        name: "Privilege",
        code: "Privilege",
        icon: <UnlockOutlined />,
        path: "/privilege",
        element: <Privilege />,
      },
      {
        name: "Access Control List",
        code: "Access Control List",
        icon: <SafetyCertificateOutlined />,
        path: "/access-control-list",
        element: <AccessControlList />,
      },
      {
        name: "Warehouse",
        code: "Warehouse",
        icon: <HomeOutlined />,
        path: "/warehouse",
        element: <Warehouse />,
      },
      {
        name: "Area",
        code: "Area",
        icon: <BankOutlined />,
        path: "/area",
        element: <Area />,
      },
      {
        name: "RFID",
        code: "RFID",
        icon: <DeploymentUnitOutlined />,
        path: "/rfid",
        element: <DeviceSensor />,
      },
      {
        name: "Pallet",
        code: "Pallet",
        icon: <GoldOutlined />,
        path: "/pallet",
        element: <Pallet />,
      },
      {
        name: "Product Type",
        code: "Product Type",
        icon: <ProductOutlined />,
        path: "/product-type",
        element: <ProductType />,
      },
      {
        name: "Product Cost",
        code: "Product Cost",
        icon: <ProductOutlined />,
        path: "/product-cost",
        element: <ProductCost />,
      },
      {
        name: "Product",
        code: "Product",
        icon: <ProductOutlined />,
        path: "/product",
        element: <Product />,
      },
      {
        name: "Material Handling",
        code: "Material Handling",
        icon: <DiffOutlined />,
        path: "/material-handling",
        element: <MaterialHandling />,
      },
    ],
  },
];
